module.exports = __webpack_public_path__ + "img/6.71a029ae.gif";